import React from 'react';

function Percentage() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <circle cx="13" cy="13" r="13" fill="#EFE5FF" />
      <mask
        id="mask0_6586_110247"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="16"
        height="16"
      >
        <rect x="5" y="5" width="16" height="16" fill="#6930CA" />
      </mask>
      <g mask="url(#mask0_6586_110247)">
        <path
          d="M9.98958 12.3229C9.34514 12.3229 8.79514 12.0951 8.33958 11.6396C7.88403 11.184 7.65625 10.634 7.65625 9.98958C7.65625 9.34514 7.88403 8.79514 8.33958 8.33958C8.79514 7.88403 9.34514 7.65625 9.98958 7.65625C10.634 7.65625 11.184 7.88403 11.6396 8.33958C12.0951 8.79514 12.3229 9.34514 12.3229 9.98958C12.3229 10.634 12.0951 11.184 11.6396 11.6396C11.184 12.0951 10.634 12.3229 9.98958 12.3229ZM9.98958 10.9896C10.2674 10.9896 10.5035 10.8924 10.6979 10.6979C10.8924 10.5035 10.9896 10.2674 10.9896 9.98958C10.9896 9.71181 10.8924 9.47569 10.6979 9.28125C10.5035 9.08681 10.2674 8.98958 9.98958 8.98958C9.71181 8.98958 9.47569 9.08681 9.28125 9.28125C9.08681 9.47569 8.98958 9.71181 8.98958 9.98958C8.98958 10.2674 9.08681 10.5035 9.28125 10.6979C9.47569 10.8924 9.71181 10.9896 9.98958 10.9896ZM15.9896 18.3229C15.3451 18.3229 14.7951 18.0951 14.3396 17.6396C13.884 17.184 13.6562 16.634 13.6562 15.9896C13.6562 15.3451 13.884 14.7951 14.3396 14.3396C14.7951 13.884 15.3451 13.6562 15.9896 13.6562C16.634 13.6562 17.184 13.884 17.6396 14.3396C18.0951 14.7951 18.3229 15.3451 18.3229 15.9896C18.3229 16.634 18.0951 17.184 17.6396 17.6396C17.184 18.0951 16.634 18.3229 15.9896 18.3229ZM15.9896 16.9896C16.2674 16.9896 16.5035 16.8924 16.6979 16.6979C16.8924 16.5035 16.9896 16.2674 16.9896 15.9896C16.9896 15.7118 16.8924 15.4757 16.6979 15.2812C16.5035 15.0868 16.2674 14.9896 15.9896 14.9896C15.7118 14.9896 15.4757 15.0868 15.2812 15.2812C15.0868 15.4757 14.9896 15.7118 14.9896 15.9896C14.9896 16.2674 15.0868 16.5035 15.2812 16.6979C15.4757 16.8924 15.7118 16.9896 15.9896 16.9896ZM8.58958 18.3229L7.65625 17.3896L17.3896 7.65625L18.3229 8.58958L8.58958 18.3229Z"
          fill="#6930CA"
        />
      </g>
    </svg>
  );
}

export default Percentage;
